import React from 'react';

export function Ranking({ ranking }) {
  if (!ranking?.length) return null;
  return (
    <section className="panel ranking-panel">
      <div className="panel-heading"><div><span className="eyebrow">Endstand</span><h2>Rangliste</h2></div></div>
      <div className="ranking-list">
        {ranking.map((entry) => (
          <article key={entry.id} className={`ranking-row rank-${entry.rank}`}>
            <span className="rank-number">{entry.rank}</span>
            <span className="ranking-avatar">{entry.isBot ? '🤖' : entry.name.slice(0, 1).toUpperCase()}</span>
            <div><strong>{entry.name}</strong><small>{Object.entries(entry.score.rows).map(([color, value]) => `${color.slice(0,1).toUpperCase()} ${value}`).join(' · ')} · Fehlwürfe −{entry.score.penalty}</small></div>
            <b>{entry.score.total} P.</b>
          </article>
        ))}
      </div>
    </section>
  );
}
